// extracted by mini-css-extract-plugin
export const mainLayout = "bg_cC";
export const leftSection = "bg_bv";
export const rightSection = "bg_br";